import { render, staticRenderFns } from "./NameItem.vue?vue&type=template&id=7beaed0a&"
import script from "./NameItem.vue?vue&type=script&lang=js&"
export * from "./NameItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports